import type { Summary } from "../api/models";

export function pct(n: number, d: number): string {
  if (d === 0) return "—";
  return `${((100 * n) / d).toFixed(1)}%`;
}

export function accuracy(summary: Summary | null): {
  correct: string;
  verified: string;
  top3: string;
  verifiedTop3: string;
} {
  if (!summary) return { correct: "—", verified: "—", top3: "—", verifiedTop3: "—" };
  return {
    correct: pct(summary.correct, summary.scored),
    verified: pct(summary.verifiedCorrect, summary.verified),
    top3: summary.top3 === undefined ? "—" : pct(summary.top3, summary.scored),
    verifiedTop3: summary.verifiedTop3 === undefined ? "—" : pct(summary.verifiedTop3, summary.verified),
  };
}
